import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './Router/AppRouter';

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import './styles/styles.css';

import translationEN from './Locales/en/translation.json';
import translationFR from './Locales/fr/translation.json';

export default function(){

  // the translations
  const resources = {
      en: {
        translation: translationEN
      },
      fr:{
        translation: translationFR
      }
    };
    
    i18n
        .use(initReactI18next)
        .init({
            resources,
            lng: "en",
            fallbackLng: "en"
        });

  document.documentElement.lang = "en";

  ReactDOM.render(<AppRouter />, document.getElementById('app'));

}